$( document ).ready(function() {
//TO DO
// Add TM supercript to instances of High Performance Snack, Rejuvenation Snack and Nutrition for Achievers
  var subtotal;
  var shipping__text = $('.shipping');
  var subtotalCont  = $('.ajaxcart__subtotal')[1];
  var shippingDiscountLimit = 59.99;
  var subtotalNum;
  var subtotalCont;


  var overwriteShippingText = function(price) {
    if (price > shippingDiscountLimit) {
      $(subtotalCont).html('<em>Free Shipping</em> on this order!');
    } else {
      $(subtotalCont).html('$3.99');
    }
  };

  $('#CartContainer').on('DOMSubtreeModified', function() {
    var subtotalNum = $(subtotalCont).html();
    subtotal = parseFloat( $(subtotalCont).html().replace("$", "") );
    overwriteShippingText(subtotal);
  })


  $('.yotpo.bottomLine.black').on('click', (e)=> {
      var x = document.getElementById('reviews');
      x.scrollIntoView();
  });
  
  

});
